import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg4 from "../assets/img/project-img4.jpeg";
import projImg2 from "../assets/img/project-img2.jpeg";
import projImg3 from "../assets/img/project-img3.jpeg";
import projImg5 from "../assets/img/project-img5.jpeg";
import projImg6 from "../assets/img/project-img6.jpeg";
import projImg7 from "../assets/img/project-img7.jpeg";
import projImg8 from "../assets/img/project-img8.jpeg";
import projImg9 from "../assets/img/project-img9.jpeg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import blessedtonia from "../assets/img/blessedtonia.jpeg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Blessed-Tonia Agro Store",
      description: " Web Design & Development",
      imgUrl: blessedtonia,
      PageLink: "https://blessed-tonia.web.app/"
    },
    {
      title: "SoccerVerse",
      description: "Design & Development",
      imgUrl: projImg2,
      PageLink: "https://emerald-techwiz-project.netlify.app/"
    },
    {
      title: "Jem's Pen",
      description: "Design & Development",
      imgUrl: projImg3,
      PageLink: "https://jem-s-pen.firebaseapp.com/"
    },
    {
      title: "Global Evangelical Ministries",
      description: "Design & Development",
      imgUrl: projImg4,
      PageLink: "https://gem-webapp.web.app/"
    },
    {
      title: "Book-Library",
      description: " Web Design & Development",
      imgUrl: projImg7,
      PageLink: "https://bookreader-three.vercel.app/"
    },
    {
      title: "Crypto-Tracker",
      description: "Design & Development",
      imgUrl: projImg8,
      PageLink: "https://crypto001.vercel.app/"
    },
    {
      title: "Guess that pokemon game",
      description: "Design & Development",
      imgUrl: projImg6,
      PageLink: "https://guess-that-pokemon-eight.vercel.app/"
    },
    {
      title: "Snake-Game",
      description: "Design & Development",
      imgUrl: projImg5,
      PageLink: "https://snake-game-three-alpha.vercel.app/"
    },
    {
      title: "Trello-Clone",
      description: "Design & Development",
      imgUrl: projImg9,
      PageLink: "https://trello-clone-seven-vert.vercel.app/"
    },

];


  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
               <h2>My Projects</h2> 
               <p>I have created various web based projects and made some videos to showcase my skills and creativity. Here are some of the projects i recently completed:</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Page 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Page 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Page 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="colorSharp" />
    </section>
  )
}